var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"cp-plain-header clearfix"},[_c('transition-group',{attrs:{"name":"fade","tag":"div","appear":""}},[_c('MainNavigationBlack',{key:"2"}),_c('h2',{key:"0",staticClass:"cp-header-logo"},[_c('CpLogoBlack')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }